'use strict'

let request=require('superagent');

function sendCommand(command) {
  return new Promise((resolve,reject)=>{
    request
      .post("/")
      .send(command)
      .end(function(error, response) {
        if (error===null && response.status===200) {
          var message=JSON.parse(response.text);
          if (message.status==="OK") {
            console.log("Success for command '"+command.type+"'");
            resolve(message);
          } else {
            console.log("Error: "+message.message);
            reject({status:200, message: message.message});
          }
        } else {
          console.log("Error: "+error+", got "+response.status+" with message "+response.text);
          reject({status: response.status, message: response.text})
        }
      });
    })
}

module.exports=sendCommand;



// WEBPACK FOOTER //
// ./app/utils/sendCommand.js